import { render } from "./Header.vue?vue&type=template&id=b278a540&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=b278a540&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1035701240/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b278a540"]])

export default __exports__